module.exports = __webpack_public_path__ + "static/img/kongzhi.b9863672.png";